import {defineStore} from 'pinia'
import axios from 'axios'

export const useMiniConfigurateurStore = defineStore('miniConfigurateur', {
    state: () => ({
        voiture_id: null,
        circuit_id: null,
        nb_tours: 0,
        nb_tours_bapteme: 0,
        circuits: [],
        voitures: [],
    }),
    persist: {},
    getters: {},
    actions: {},
})
